import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Table } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { analytics } from 'app/utils/segment';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { ConversationsTableActions } from './components/rowCells/actions/conversationsTableActions';
import { ConversationsTableAssignedAgent } from './components/rowCells/assignedAgent/conversationsTableAssignedAgent';
import { ConversationsTableChannel } from './components/rowCells/channel/conversationsTableChannel';
import { ConversationsTableCsid } from './components/rowCells/csid/conversationsTableCsid';
import { ConversationsTableCustomer } from './components/rowCells/customer/conversationsTableCustomer';
import { ConversationsTableQueue } from './components/rowCells/queue/conversationsTableQueue';
import { ConversationsTableStatus } from './components/rowCells/status/conversationsTableStatus';
import { ConversationsTableTimestamp } from './components/rowCells/timestamp/conversationsTableTimestamp';
import styles from './conversationsTableConversationRow.module.scss';
import { ConversationRowContext } from './utils/conversationRowContext';
export const ConversationsTableConversationRow = ({ conversationAndRequester, }) => {
    const navigate = useAppNavigate();
    const navigateToConversation = useCallback(() => navigate({
        path: '/conversation/:csid',
        params: {
            path: {
                csid: conversationAndRequester.conversation.id.toString(),
            },
        },
    }), [conversationAndRequester.conversation.id, navigate]);
    /** Handles clicking the row. */
    const handleRowClick = useCallback(({ target }) => {
        var _a, _b, _c;
        if (target instanceof HTMLInputElement ||
            target instanceof HTMLButtonElement ||
            target instanceof SVGElement ||
            // Assumes that the first cell in the row is the implicitly added
            // checkbox cell. If for some reason the checkbox is ever going to be
            // optional then it should be guarded here.
            (target instanceof HTMLTableCellElement &&
                ((_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.childNodes[0]) === target) ||
            (target instanceof HTMLTableCellElement &&
                ((_b = target.parentElement) === null || _b === void 0 ? void 0 : _b.childNodes[((_c = target.parentElement) === null || _c === void 0 ? void 0 : _c.childNodes.length) - 1]) === target)) {
            return;
        }
        navigateToConversation();
        analytics.conversationsGoToConversationClicked();
    }, [navigateToConversation]);
    return (_jsx(ConversationRowContext.Provider, Object.assign({ value: { conversationAndRequester } }, { children: _jsxs(Table.Tr, Object.assign({ className: styles.root, rowId: conversationAndRequester.conversation.id, onClick: handleRowClick }, { children: [_jsx(Table.Td, { children: _jsx(ConversationsTableCsid, {}) }), _jsx(Table.Td, { children: _jsx(ConversationsTableCustomer, {}) }), _jsx(Table.Td, { children: _jsx(ConversationsTableQueue, {}) }), _jsx(Table.Td, { children: _jsx(ConversationsTableStatus, {}) }), _jsx(Table.Td, { children: _jsx(ConversationsTableChannel, {}) }), _jsx(Table.Td, { children: _jsx(ConversationsTableAssignedAgent, {}) }), _jsx(Table.Td, { children: _jsx(ConversationsTableTimestamp, { timestampKey: "last_message_created_at" }) }), _jsx(Table.Td, { children: _jsx(ConversationsTableTimestamp, { timestampKey: "created_at" }) }), _jsx(Table.Td, { children: _jsx(ConversationsTableActions, {}) })] })) })));
};
